var render = function (_h,_vm) {var _c=_vm._c;return _c('v-list',[_c('v-list-tile',[_c('v-list-tile-title',{staticClass:"list-tile-title text-xs-center mt-4"},[_vm._v(_vm._s(_vm.props.text))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }